import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { BreadcrumbsPropsModel, BreadcrumsModel } from '../../../Models'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import { CustomTooltip } from '../CustomToolTip/CustonToolTip'
import CONSTANTS from '../../../Constants'
import { layoutIdInSessionStorage } from '../../../Helpers/Util'
import UnsavedPopup from '../UnsavedPopup'

const Breadcrumbs: React.FC<BreadcrumbsPropsModel> = ({
  breadcrums,
  isFormUpdated,
  isMarginTop = true,
  saveDraftCallback,
}) => {
  const [openDialog, setOpenDialog] = useState(false)
  const [pendingNavigation, setPendingNavigation] = useState<{
    item: BreadcrumsModel
    index: number
  } | null>(null)
  const navigate = useNavigate()

  const handleOnNavigate = (item: BreadcrumsModel, index: number) => {
    const endPath = breadcrums.length - 1

    if (breadcrums[endPath]?.label !== item?.label && isFormUpdated) {
      // Store the pending navigation info and open the dialog
      setPendingNavigation({ item, index })
      setOpenDialog(true)
    }
  }

  const handleConfirmNavigation = () => {
    layoutIdInSessionStorage('remove')
    if (pendingNavigation) {
      const { item, index } = pendingNavigation
      navigate(index < breadcrums.length - 1 ? item.path : {})
      setPendingNavigation(null) // Clear the pending navigation state
    }
    setOpenDialog(false) // Close the dialog
  }

  const renderLinkElement = (item: BreadcrumsModel, index: number) => (
    <Link
      to={index < breadcrums.length - 1 ? item.path : '#'}
      className={`breadcrums__link ${item.active ? 'active font-bold' : ''}`}
      onClick={(e) => {
        if (breadcrums[breadcrums.length - 1]?.label !== item?.label && isFormUpdated) {
          e.preventDefault()
          handleOnNavigate(item, index)
        }
      }}
    >
      <div className='d-flex align-items-center justify-content-center'>
        <div className='capitalize' style={{ cursor: 'pointer' }}>
          {item.label}
        </div>{' '}
        {!item.active && (
          <div className='d-flex justify-content-center align-items-center breadCrums__icon'>
            <ChevronRightIcon sx={{ fontSize: '16px' }} />
          </div>
        )}
      </div>
    </Link>
  )

  return (
    <>
      <UnsavedPopup
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={async () => {
          await saveDraftCallback?.()
        }}
        onCloseDialog={handleConfirmNavigation}
      />
      <div className={`d-flex align-items-center pr-3 ${isMarginTop && 'breadcrums'}`}>
        {breadcrums.map((item, index) =>
          item?.showTooltip ? (
            <CustomTooltip
              data-testid='tooltip-breadcrums'
              title={item.tooltipText}
              key={item.label}
              placement='bottom'
              arrow
            >
              {renderLinkElement(item, index)}
            </CustomTooltip>
          ) : (
            renderLinkElement(item, index)
          ),
        )}
      </div>
    </>
  )
}

export default Breadcrumbs
